import { defineEvent } from "@visioni/a3s-analytics";
import type { DeterrenceDevice } from "@visioni/a3s-deterrence/app";
import type { CameraScope } from "@src/features/cameras/analytics";
import type { RequestErrorType } from "@src/services/api/error-type";

// Tracked in `useDeterrenceTest`, shared by the web card and the native camera page,
// once per confirmed press that sends a command. A press refused while the device is
// held sends no command and no event.

/** `device` is the one output the press tested. */
type DeterrenceTestProps = CameraScope & { device: DeterrenceDevice };

/**
 * The trigger command was accepted for delivery. Not that the hardware fired: the
 * edge reports no acknowledgement, and the asset may have no hardware wired.
 */
export const DeterrenceTestTriggered = defineEvent<DeterrenceTestProps>("Deterrence Test Triggered");
export const DeterrenceTestFailed = defineEvent<DeterrenceTestProps & { error_type: RequestErrorType }>(
  "Deterrence Test Failed",
);
